export default "__VITE_ASSET__$seTBSHo__"